import React from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { FiBell } from "react-icons/fi";
import style from "../styles/Notification.module.css";
import "../Components/NotificationDropdown/Notifications.css";
import AllNotifications from "../Components/NotificationDropdown/AllNotifications";
import ReadNotifications from "../Components/NotificationDropdown/ReadNotifications";
import UnreadNotifications from "../Components/NotificationDropdown/UnreadNotifications";
const AdminNotifications = () => {
  return (
    <Container fluid>
      <div className="mx-md-5">
        <div className="notif-page-header">
          <div className="notif-page-identity">
            <span className="notif-page-icon">
              <FiBell />
            </span>
            <div>
              <h1 className="notif-page-title">Notifications</h1>
              <span className="notif-page-subtitle">View and manage all your admin notifications</span>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 border-0 rounded-3 shadow-sm">
          <Row style={{ marginBottom: "-3rem" }} className="mt-1">
            <Col>
              <Tabs defaultActiveKey="All" className={`${style.navtabs} notif-tabs`}>
                <Tab eventKey="All" title="All" className="text-secondary mb-5">
                  <AllNotifications />
                </Tab>
                <Tab eventKey="Read" title="Read" className="text-secondary mb-5">
                  <ReadNotifications />
                </Tab>
                <Tab eventKey="Unread" title="Unread" className="text-secondary mb-5">
                  <UnreadNotifications />
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
};

export default AdminNotifications;
